/**
 * Wire contracts shared with the Backend. Mirrors `CricketScorer.Contracts.Auth`.
 * Generated-by-hand for v1; Phase 8 will switch to openapi-typescript codegen.
 */

export interface RequestOtpRequest {
  mobile: string;
}

export interface RequestOtpResponse {
  maskedMobile: string;
  expiresAt: string; // ISO 8601
  isNewUser: boolean;
  /** Only present when the Console OTP provider is active (dev). Remove before production. */
  devOtp?: string;
}

/**
 * Why the caller is verifying an OTP.
 *
 * `signup` is only sent by the "Create an account" entry point. The server rejects it with
 * `auth.otp.account_exists` when the mobile already has a password, so an OTP can never be
 * used as a shortcut past password sign-in. Absent/`reset` means "set a new password".
 */
export type OtpIntent = 'signup' | 'reset';

export interface VerifyOtpRequest {
  mobile: string;
  otp: string;
  displayName?: string;
  deviceFingerprint?: string;
  /** Required. The verified mobile always gets this password (sign-up / forgot-password reset). */
  password: string;
  purpose: OtpIntent;
}

export interface LoginWithPasswordRequest {
  mobile: string;
  password: string;
  deviceFingerprint?: string;
}

export interface RefreshRequest {
  refreshToken: string;
  deviceFingerprint?: string;
}

export interface AuthUser {
  userId: string;
  displayName: string;
  mobile: string;
}

export interface AuthTokens {
  user: AuthUser;
  accessToken: string;
  accessTokenExpiresAt: string;
  refreshToken: string;
  refreshTokenExpiresAt: string;
}

export interface ApiProblem {
  type?: string;
  title: string;
  status: number;
  detail?: string;
}

export class ApiError extends Error {
  constructor(
    message: string,
    public readonly status: number,
    public readonly code?: string,
  ) {
    super(message);
    this.name = 'ApiError';
  }
}
